import { actionCreatorFactory } from "typescript-fsa";
import { credgrpdata } from "../typing/table_typing";


const actionCreator = actionCreatorFactory("CREDGRPTABLE");

 const resetData = actionCreator<{data:credgrpdata[]}>("CREDGRP_RESETDATA");

 export const TableThingyActions = { resetData}


